import React from 'react';
import PropTypes from 'prop-types';
import styles from './DesktopOverlay.module.scss';
import { OverlayContent } from '../';
import { Card, CardBody, FontAwesomeProIcon } from '@wienenergiegithub/ui-next';
import { Button } from '@ariakit/react';

const DesktopOverlay = ({
  linkList,
  setOverlayVisibility,
  store,
  formSuccess,
  pageLink,
}) => {
  const handleClose = () => setOverlayVisibility(false);

  return (
    <Card className={styles.container}>
      <CardBody>
        <Button
          aria-label="Produktberater löschen"
          className={styles.button}
          onClick={handleClose}
        >
          <FontAwesomeProIcon
            className={styles.icon}
            fixedWidth
            icon="times"
            role="presentation"
          />
        </Button>
        <OverlayContent
          formSuccess={formSuccess}
          linkList={linkList}
          pageLink={pageLink}
          setOverlayVisibility={setOverlayVisibility}
          store={store}
        />
      </CardBody>
    </Card>
  );
};

DesktopOverlay.propTypes = {
  formSuccess: PropTypes.bool,
  linkList: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string,
      label: PropTypes.string,
      link: PropTypes.string,
    }),
  ).isRequired,
  pageLink: PropTypes.string,
  setOverlayVisibility: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  store: PropTypes.object.isRequired,
};

export { DesktopOverlay };
